import { render, staticRenderFns } from "./AffiliationMicrosite.vue?vue&type=template&id=556cf2fa&scoped=true"
import script from "./AffiliationMicrosite.vue?vue&type=script&lang=js"
export * from "./AffiliationMicrosite.vue?vue&type=script&lang=js"
import style0 from "./AffiliationMicrosite.vue?vue&type=style&index=0&id=556cf2fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556cf2fa",
  null
  
)

export default component.exports